import React, { useEffect, useState } from 'react';
import styles from './index.module.less';
import { Affix, Col, Row, Skeleton } from 'antd';
import { ArticleDetailModel, HomeArticleModel } from '@/types/home';
import BookItem from '../BookItem';
import HomeFullItem from '@/components/Home/HomeFullItem';
import ArticleRightItemList from '../ArticleRightItemList';
import { imgUrl } from '@/shared/utils';
import useScreenSize from '@/lib/hooks/utils/useScreenSize';
import SharePage from '@/components/Common/Share';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { HairLibPublicModel } from '@/types/hairstyle';
import VirtualHairstyleTryOnContent from '@/components/Common/VirtualHairstyleTryOnContentToHome';
import ReactECharts from 'echarts-for-react';
import BottomFlexButton from '../BottomFlexButton';
const ArticleDetailUI = ({
  model,
  articleList,
  contentData,
  recommendTags,
  randomHairList,
  hairArticleData
}: {
  model?: ArticleDetailModel;
  articleList?: [HomeArticleModel];
  contentData?: any;
  recommendTags?: [HomeArticleModel];
  randomHairList?: [HairLibPublicModel];
  hairArticleData?: any;
}) => {
  const { t } = useTranslation();
  const { width } = useScreenSize();
  const [currentHref, setCurrentHref] = useState('');

  useEffect(() => {
    setCurrentHref(window.location.href);
  }, []);

  const [processedContent, setProcessedContent] = useState({ updatedHtml: '', h2Contents: [] });

  useEffect(() => {
    if (!contentData?.body) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(contentData.body, 'text/html');
    let elements = doc.querySelectorAll('h2');
    const h2Contents: string[] = [];

    if (elements.length === 0) {
      elements = doc.querySelectorAll('h3');
    }

    elements.forEach((el, index) => {
      h2Contents.push(el.textContent || '');
      el.id = `${index + 1}`;
      el.style.scrollMarginTop = '80px';
    });

    const imgElements = doc.querySelectorAll('img');
    imgElements?.forEach((img) => {
      if (!img.hasAttribute('loading')) {
        img.setAttribute('loading', 'lazy');
      }

      const originalSrc = img.getAttribute('src');
      if (originalSrc) {
        img.setAttribute('src', imgUrl(originalSrc, width > 576 ? 'big' : 'mid'));
      }
    });

    setProcessedContent({
      updatedHtml: doc.body.innerHTML,
      h2Contents
    });
  }, [contentData?.body, width]);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <Skeleton active />;
  }

  const itemList = () => {
    return <ArticleRightItemList dataList={randomHairList} />;
  };

  const smoothLineOption = {
    tooltip: {
      trigger: 'axis',
      formatter: '{b}: {c}'
    },
    grid: {
      top: 20,
      bottom: 40,
      left: 50,
      right: 0
    },
    xAxis: {
      type: 'category',
      data: hairArticleData?.trend?.trend_data[0]?.counts
        ? hairArticleData?.trend?.trend_data[0]?.counts?.map((item: any) => item?.date)
        : [],
      axisLabel: {
        formatter: function (value: any, index: number) {
          return index % 2 === 0 ? value : '';
        }
      },
      axisLine: {
        lineStyle: {
          type: 'dashed'
        }
      }
    },
    yAxis: {
      type: 'value',
      // inverse: true,
      splitLine: {
        lineStyle: {
          type: 'dashed',
          color: '#FFF'
        }
      }
    },

    series: [
      {
        // data: data ? data.rank_list?.map((item) => item?.ranking) : [],
        data: hairArticleData?.trend?.trend_data[0]?.counts
          ? hairArticleData?.trend?.trend_data[0]?.counts?.map((item: any) => item?.count)
          : [],
        type: 'line',
        smooth: true,
        showSymbol: false,
        itemStyle: {
          color: '#9873ff'
        }
      }
    ]
  };

  const barOption = {
    tooltip: {
      trigger: 'axis',
      formatter: '{b}: {c}'
    },
    grid: {
      top: 20,
      bottom: 40,
      left: 50,
      right: 0
    },
    xAxis: {
      type: 'category',
      data: hairArticleData?.trend?.age_distribution
        ? Object.keys(hairArticleData?.trend?.age_distribution)?.map((item: any) => item)
        : [],
      axisLabel: {
        formatter: function (value: any, index: number) {
          return index % 2 === 0 ? value : '';
        }
      },
      axisLine: {
        lineStyle: {
          type: 'dashed'
        }
      }
    },
    yAxis: {
      type: 'value',
      // inverse: true,
      splitLine: {
        lineStyle: {
          type: 'dashed',
          color: '#FFF'
        }
      }
    },
    series: [
      {
        // data: data ? data.rank_list?.map((item) => item?.ranking) : [],
        data: hairArticleData?.trend?.age_distribution
          ? Object.values(hairArticleData?.trend?.age_distribution)?.map((item: any) => item)
          : [],
        type: 'bar',
        smooth: true,
        showSymbol: false,
        itemStyle: {
          color: '#9873ff'
        }
      }
    ]
  };

  return (
    <div className={styles.popularProductsContainer}>
      {width > 1170 && currentHref && (
        <div style={{ float: 'left', marginLeft: `${(width - 1060) / 2 - 55}px` }}>
          <Affix offsetTop={74}>
            <SharePage shareUrl={currentHref} />
          </Affix>
        </div>
      )}

      <div className={styles.homeContent}>
        <Row gutter={20}>
          <Col md={18} xs={24}>
            <div className={styles.leftContainer}>
              {contentData == undefined || contentData?.title == undefined ? (
                <>
                  <Skeleton active />
                  <Skeleton.Image active style={{ marginTop: '20px', width: '100%', aspectRatio: '16/9' }} />
                  <Skeleton active style={{ marginTop: '20px' }} />
                </>
              ) : (
                <>
                  <div className={styles.time}>{model?.create_time}</div>
                  {contentData?.book && <BookItem contentData={contentData} />}

                  <h1 className={styles.title}>{contentData?.title}</h1>

                  {hairArticleData?.images?.link_list?.length > 0 && (
                    <div className={styles.topArticle}>
                      <h2 className={styles.subTitle}>{`Top 5 Popular Hairstyle Pictures`}</h2>
                      <p
                        className={styles.subDesc}
                      >{`Light up the ⭐ on any photo to add it to Your Style Lib, so you can try on your favorite hairstyle!`}</p>
                      {hairArticleData?.images?.link_list.length != 0 ? (
                        <ul>
                          {hairArticleData?.images?.link_list?.map((item: any) => {
                            return (
                              <li key={item?.s3_img_link}>
                                <div className={styles.imgContainer}>
                                  <img
                                    src={imgUrl(item?.s3_img_link, 'mid')}
                                    alt={item?.title}
                                    onClick={() => window.open(item.a_link, '_blank')}
                                    style={{ cursor: 'pointer' }}
                                  />
                                  <p>{`@${item?.pinner_name}`}</p>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      ) : (
                        <></>
                      )}
                    </div>
                  )}

                  <VirtualHairstyleTryOnContent style={{ marginTop: '20px', cursor: 'pointer' }} />

                  {hairArticleData.trend?.trend_data.length > 0 ? (
                    <div className={styles.dataCharts}>
                      <h2 className={styles.subTitle}>{`Hairstyle Popularity and Gender Distribution`}</h2>
                      <div className={styles.chartContainer1}>
                        <ReactECharts
                          style={{ width: '100%' }}
                          option={smoothLineOption}
                          // notMerge={true}
                          lazyUpdate={true}
                        />
                      </div>
                      <div className={styles.chartContainer2}>
                        <ReactECharts
                          style={{ width: '100%' }}
                          option={barOption}
                          // notMerge={true}
                          lazyUpdate={true}
                        />
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  {contentData?.image_url && (
                    <Image
                      className={styles.image}
                      src={imgUrl(contentData?.image_url, 'big')}
                      loading="lazy"
                      alt={contentData?.image_text}
                      layout="responsive"
                      width={500}
                      height={500}
                    />
                  )}

                  {
                    // (contentData?.description || contentData?.introduction) && (
                    //   <p
                    //     className={styles.desc}
                    //     dangerouslySetInnerHTML={{
                    //       __html: contentData?.description || contentData?.introduction,
                    //     }}
                    //   />
                    // )
                  }

                  {processedContent.h2Contents?.length > 0 && (
                    <div className={styles.articleTable}>
                      <span>{t('Table of Content')}</span>
                      <ul>
                        {processedContent.h2Contents?.map((item: any, index: number) => {
                          return (
                            <li key={index}>
                              <Link className={styles.liLink} href={`/article/${model?.title_id}#${index + 1}`}>
                                {item}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  )}

                  {processedContent.updatedHtml && (
                    <div
                      className={styles.content}
                      dangerouslySetInnerHTML={{ __html: processedContent.updatedHtml }}
                    />
                  )}

                  {recommendTags?.length > 0 && (
                    <div className={styles.recommendTags}>
                      <h2>{t('Read More')}</h2>
                      {(recommendTags ?? []).map((item: HomeArticleModel, index: number) => {
                        return (
                          <div className={styles.linkContainer} key={item?.article_id}>
                            <span>{index + 1}.</span>
                            <Link className={styles.link} href={`/article/${item?.title_id}`}>
                              {item.title}
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {model?.labels?.length > 0 && (
                    <div className={styles.tagContiner}>
                      <span className={styles.tagTitle}>{t('tags')}:</span>
                      {(model?.labels ?? []).map((item: any, index: number) => {
                        const itemStr = index == model?.labels.length - 1 ? item : `${item},`;
                        return (
                          <Link href={`/search?tag=${item}`} key={index} className={styles.tagContent}>
                            {itemStr}
                          </Link>
                        );
                      })}
                    </div>
                  )}

                  {width <= 1170 && <SharePage shareUrl={currentHref} />}
                </>
              )}
            </div>

            <div className={styles.otherContainer}>
              {articleList != undefined && articleList?.length > 1 && (
                <>
                  <h3>{t('peopleAlsoEnjoyed')}</h3>
                  {(articleList ?? []).map((item, index) => {
                    return (
                      <HomeFullItem
                        key={index}
                        showBottomLine={index != articleList.length - 1}
                        articleModel={item}
                        showPadding={false}
                      />
                    );
                  })}
                </>
              )}
            </div>
          </Col>
          {width > 768 && (
            <Col md={6} xs={24}>
              {itemList()}
            </Col>
          )}
        </Row>
      </div>

      <BottomFlexButton model={model.article_button} />
    </div>
  );
};

export default ArticleDetailUI;
